import { render } from "./Garden.vue?vue&type=template&id=cfcfef7a"
import script from "./Garden.vue?vue&type=script&lang=js"
export * from "./Garden.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__